module.exports = __webpack_public_path__ + "static/media/spi.898e30c3.png";